import React from "react";
import { Row, Col } from "react-bootstrap";
import { GoogleLogin } from "react-google-login";
import { gapi } from "gapi-script";
import btn_google_signin from "../../images/btn_google_signin.svg";
import btn_microsoft_signin from "../../images/_x32_16-microsoft.svg";

import { UserAgentApplication } from "msal";
import { config } from "./ms-login/Config";

import { GOOGLE_CLIENT_ID } from "../../config/appConfig";

const queryString = window.location.search;
const queryParams = new URLSearchParams(queryString);

let loginType = queryParams.get("type");

function gapiStart() {
  gapi.client.init({
    clientId: GOOGLE_CLIENT_ID,
    scope: ""
  });
}
/* eslint-disable react/prefer-stateless-function */
class SocialLogin extends React.Component {
  constructor(props) {
    super(props);

    gapi.load("client:auth2", gapiStart);

    this.userAgentApplication = new UserAgentApplication({
      auth: {
        clientId: config.clientId,
        redirectUri: config.redirectUri
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true
      }
    });
  }

  shouldComponentUpdate() {
    return true;
  }
  responseGoogle = response => {
    console.log("response", response);

    if (response.error && response.error !== "") {
      return false;
    }
    this.props.onResponse({
      social: "google",
      access_token: response.tokenObj.access_token,
      id_token: response.tokenObj.id_token,
      login_hint: response.tokenObj.login_hint,
      email: response.profileObj.email,
      name: response.profileObj.name
    });
  };
  responseLinkedin = res => {
    let response = res;

    this.props.onResponse({
      social: "linkedin",
      id_token: response.id,
      email: response.emailAddress,
      name: response.firstName
    });

    // console.log(response);
    console.log("linkedIn");
  };

  /**
   * Microsoft login handler
   * @param {*} data
   */
  authHandlerMicrosoft = data => {
    if (data && data.account) {
      let id_token = data.idToken.rawIdToken;
      let authData = {
        account: {
          homeAccountId:
            data.account.idTokenClaims.oid +
            "." +
            data.account.idTokenClaims.tid, // "00000000-0000-0000-d3e1-e1b808db9a96.9188040d-6c67-4c5b-b112-36a304b66dad",
          tenantId: data.account.idTokenClaims.tid,
          localAccountId: data.account.accountIdentifier,
          idTokenClaims: data.account.idTokenClaims
        }
      };
      let email = data.account.userName;
      let name = data.account.name
        ? data.account.name
        : data.account.userName.split("@")[0];

      this.props.onResponse({
        social: "microsoft",
        id_token: id_token,
        authData: authData,
        email: email,
        name: name
      });
    }
  };

  /**
   * Microsoft login popup
   */
  msLoginPopup = async () => {
    try {
      await this.userAgentApplication
        .loginPopup({
          scopes: config.scopes,
          prompt: "consent",
          response_type: "code"
        })
        .then(this.authHandlerMicrosoft)
        .catch(error => {
          console.error(error);
        });
    } catch (err) {
      console.log("Error:", err);
    }
  };
  render() {
    let { signIn } = this.props;
    return (
      <Row className="socailLoginRow">
        <Col className="socialLoginParentBtn">
          <GoogleLogin
            clientId={GOOGLE_CLIENT_ID}
            onSuccess={this.responseGoogle}
            onFailure={this.responseGoogle}
            render={renderProps => (
              <button onClick={renderProps.onClick} className="googleBtn">
                <img
                  src={btn_google_signin}
                  className="googleImg"
                  alt="google icons"
                />
                <span>Sign in with Google</span>
              </button>
            )}
          />
          <div className="ms-login-container">
            <button className="googleBtn" onClick={() => this.msLoginPopup()}>
              <img
                src={btn_microsoft_signin}
                className="googleImg"
                alt="google icons"
              />
              <span>Sign in with Microsoft</span>
            </button>
          </div>

          {/* <GoogleLogin

            clientId={GOOGLE_CLIENT_ID}
            onSuccess={this.responseGoogle}
            onFailure={this.responseGoogle}
            render={renderProps => (
              <button onClick={renderProps.onClick} className="googleBtn">
                <img
                  src={signIn ? btn_google_signin : btn_google_signup}
                  className="googleImg"
                  alt="google icons"
                /></button>
            )}
          /> */}
        </Col>
        {/* <Col sm={6}>
          <LinkedinSDK
            clientId={LINKEDIN_CLIENT_ID} //"77c8gey7x03ee6" //"81em1ooc84q0e6"
            clientSecret={LINKEDIN_SECRET} //"HlPPq2QVfHXY4463"
            fields=":(id,email-address,first-name)"
            callBack={this.responseLinkedin}
            // fields=":(id,num-connections,picture-url)"
            // loginButtonText={'Login with Linkedin'}
            // logoutButtonText={'Logout from Linkedin'}
            loginButtonText={"Sign in with LinkedIn"}
            logoutButtonText={"Logout from Linkedin"}
            buttonType={"button"}
            className="linkedInBtn"
            icon={
              <img
                src={btn_signin_linkedIn_button}
                className="linkedInImg"
                alt="LinkedIn icons"
              />
            }
          />
        </Col> */}
      </Row>
    );
  }
}

export default SocialLogin;



// WEBPACK FOOTER //
// ./src/components/SocialLogin/SocialLogin.js